{
	"submitTitle": "Wybierz materiał",
	"summary": {
		"title": "Podsumowanie",
		"declarationTypeTitle": "Typ deklaracji",
		"projectReferenceTitle": "Odniesienie do projektu"
	},
	"content": {
		"selectTheDeclarationTypeSection": {
			"title": "Wybierz typ deklaracji",
			"customerProject": {
				"title": "Projekt klienta",
				"description": "Materiał został wykorzystany w projekcie zewnętrznym. Teraz muszę przedstawić deklarację określającą redukcje emisji CO\u2082 dla mojego klienta."
			},
			"internalProjectOrProduct": {
				"title": "Projekt / produkt wewnętrzny",
				"description": "Materiał został wykorzystany w projekcie lub produkcie wewnętrznym. Muszę utworzyć deklarację, aby przypisać redukcje emisji CO\u2082 do naszych własnych działań."
			}
		},
		"addProjectReferenceSection": {
			"title": "Dodaj odniesienie do projektu",
			"subTitle": "Musisz przypisać redukcje emisji CO\u2082 do odniesienia do projektu, dla którego chcesz utworzyć deklarację.",
			"projectReferencePlaceholder": "Odniesienie do projektu"
		},
		"selectProjectSection": {
			"title": "Wybierz projekt",
			"createNewProjectPlaceholder": "Utwórz nowy projekt"
		}
	},
	"errorMessages": {
		"declarationTypeRequired": "Typ deklaracji jest wymagany",
		"projectReferenceRequired": "Odniesienie do projektu jest wymagane",
		"fetchProjectsError": "Nie udało się pobrać wcześniejszych projektów"
	}
}
